import React, {useCallback, useEffect, useState} from 'react'
import {Button} from '@consta/uikit/Button'
import {IconAdd} from '@consta/uikit/IconAdd'
import {IconDocExport} from '@consta/uikit/IconDocExport'

import GridPpkList from './component/grid.ppk.list'
import ModalPPKView from './component/modal.ppk.ppkView'
import './ppk.css'


type PpkViewMode = 'pending' | 'active' | 'archive' | 'all'

const PagePPK = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [updateKey, setUpdateKey] = useState(0)
    const [exportKey, setExportKey] = useState(0)
    const [viewMode, setViewMode] = useState<PpkViewMode>('active')
    const [summary, setSummary] = useState({total: 0, pending: 0})
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        document.title = 'АСПО.Контроль | ППК'
    }, [])

    const handleSummaryChange = useCallback((value: {total: number, pending: number}) => {
        setSummary(value)
    }, [])

    const handleModalClose = (updated: boolean) => {
        setIsModalOpen(false)
        if (updated) {
            setUpdateKey((value) => value + 1)
        }
    }

    return (
        <div className="ppk-page">
            <header className="ppk-page-header">
                <div>
                    <h1>ППК</h1>
                    <p>Реестр актов предельно проходимой глубины</p>
                </div>
                <div className="ppk-page-actions">
                    {localStorage.getItem('username') !== 'admin' && (
                        <Button
                            label="Добавить ППК"
                            iconRight={IconAdd}
                            size="s"
                            onClick={() => setIsModalOpen(true)}
                        />
                    )}
                    <Button
                        label="Экспорт"
                        iconRight={IconDocExport}
                        size="s"
                        view="secondary"
                        onClick={() => setExportKey((value) => value + 1)}
                    />
                </div>
            </header>

            <div className="ppk-toolbar">
                <div className="ppk-view-switch" aria-label="Режим отображения">
                    <button
                        type="button"
                        className={viewMode === 'active' ? 'is-active' : ''}
                        onClick={() => setViewMode('active')}
                        disabled={isLoading}
                    >
                        Актуальные
                    </button>
                    <button
                        type="button"
                        className={viewMode === 'pending' ? 'is-active' : ''}
                        onClick={() => setViewMode('pending')}
                        disabled={isLoading}
                    >
                        Неподтверждённые
                    </button>
                    <button
                        type="button"
                        className={viewMode === 'archive' ? 'is-active' : ''}
                        onClick={() => setViewMode('archive')}
                        disabled={isLoading}
                    >
                        Архив
                    </button>
                    <button
                        type="button"
                        className={viewMode === 'all' ? 'is-active' : ''}
                        onClick={() => setViewMode('all')}
                        disabled={isLoading}
                    >
                        Все
                    </button>
                </div>
                <div className="ppk-summary">
                    <span>Показано: <b>{summary.total}</b></span>
                    <span>Ожидают: <b>{summary.pending}</b></span>
                    {isLoading && <span className="ppk-loading-label">Загрузка...</span>}
                    <button
                        type="button"
                        disabled={isLoading}
                        onClick={() => setUpdateKey((value) => value + 1)}
                    >
                        {isLoading ? 'Обновляем...' : 'Обновить'}
                    </button>
                </div>
            </div>

            <GridPpkList
                isUpdate={updateKey}
                isExport={exportKey}
                viewMode={viewMode}
                onSummaryChange={handleSummaryChange}
                onLoadingChange={setIsLoading}
            />

            <ModalPPKView
                isOpen={isModalOpen}
                onClose={handleModalClose}
                props={null}
                nodeData={null}
            />
        </div>
    )
}

export default PagePPK
